/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我关注的旗舰店
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetTheaterShopFollowListParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GetTheaterShopFollowListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.TheaterDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/attentions`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
